import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AdminRole = 'admin' | 'operator';

export interface AdminInfo {
  id: number;
  username: string;
  displayName: string | null;
  role: AdminRole;
}

export type PlatformAdmin = AdminInfo;

interface State {
  token: string | null;
  admin: AdminInfo | null;
  setSession: (token: string, admin: AdminInfo) => void;
  logout: () => void;
  isAdmin: () => boolean;
}

export const useAuthStore = create<State>()(
  persist(
    (set, get) => ({
      token: null,
      admin: null,
      setSession: (token, admin) => set({ token, admin }),
      logout: () => set({ token: null, admin: null }),
      isAdmin: () => get().admin?.role === 'admin',
    }),
    {
      name: 'console-auth',
      version: 2,
      migrate: (state: unknown, version: number) => {
        // v1 token 缺 tv/role，强制重登
        if (version < 2) return { token: null, admin: null };
        return state as State;
      },
    },
  ),
);
